import { useContext, useState } from 'react'
import { Content, Title } from '../../GlobalStyle'

import { ProgressSpinner } from 'primereact/progressspinner'
import { useQuery } from 'react-query'
import { useNavigate } from 'react-router-dom'
import FormDataContext from '../../context/CreateProductsContext'
import { ModalTotalContext } from '../../context/ModalContext'
import api from '../../hooks/API'
import { useDeleteProduct } from '../../hooks/mutations'
import BoxShadow from '../components/BoxShadowDiv'
import SubHeaderRowGroupDemo from '../components/ListTable'
import ModalConfirmDelete from '../components/Modal/ModalConfirmDelete'
import ModalInfoProduct from '../components/Modal/ModalInfoProduct'

const ListProducts = () => {
  const [clicked, setClicked] = useState()
  const { openModal, setOpenModal } = useContext(ModalTotalContext)
  const navigate = useNavigate()
  const { setFormData } = useContext(FormDataContext)

  const { isLoading, data } = useQuery(['madeProducts'], () => api.getAllMadeProducts())

  const productsMade = Array.isArray(data)
    ? data
    : Array.isArray(data?.data)
      ? data.data
      : []

  const { mutate: deleteProduct } = useDeleteProduct()

  const handleClick = (event, id) => {
    event.stopPropagation()
    setOpenModal('deleteCreated')
    setClicked(id)
  }

  const deleteProductButton = () => {
    deleteProduct(clicked)
  }

  const infosProductButton = (event, val) => {
    setClicked(val)
    event.stopPropagation()
    setOpenModal('infosCreated')
  }

  const handleEdit = (e, val) => {
    e.stopPropagation()
    localStorage.setItem('isLikeComponent', val.codigo_barras ? true : false)

    setFormData({
      id: val.id,
      nome: val.nome,
      gain: val.lucro,
      components: val.componentes,
      price: val.preco_venda_unit,
      rival: '',
      quantidade: val.quantidade,
      totalCost: val.preco_custo,
      unidade: val.unidade,
    })

    navigate('/create_products', { state: true })
  }

  if (isLoading) {
    return (
      <div
        style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          width: '100%',
        }}
      >
        <ProgressSpinner size="6rem" />
      </div>
    )
  }

  return (
    <>
      <Content>
        <Title>Listar produtos</Title>
        <BoxShadow>
          <SubHeaderRowGroupDemo
            handleClick={handleClick}
            deleteProduct={deleteProduct}
            products={productsMade}
            handleEdit={handleEdit}
            infosProductButton={infosProductButton}
          />
        </BoxShadow>
      </Content>

      {openModal === 'deleteCreated' && <ModalConfirmDelete callBack={deleteProductButton} />}
      {openModal === 'infosCreated' && <ModalInfoProduct prod={clicked} />}
    </>
  )
}

export default ListProducts